module.exports = __webpack_public_path__ + "8850fb12249cf961ea2aff16397cee0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bristol_myers_squibb_2022_chart.png
// module id = 1642
// module chunks = 0